import React from "react";
import SlideDisplay from "./SlideDisplay";
import PollResults from "./PollResults";
import Gameplay from "./Gameplay";

const MainView = ({
  hideSlideDisplay,
  pollQuestion,
  pollResults,
  slideUrl,
  handleSlidePostMessage,
  currPollNumCompleted,
  gameRef,
  playtimePhase,
  discussPhase,
  gameplayRoute,
  isGamePlaying,
  setIsGamePlaying,
  timerTimes,
  setDisableArrowControls,
  handleNavigation,
  nextSlideLabel,
  timerModalInfo,
  setTimerModalInfo,
  startTimerModalCallback,
  isShowingGlossary,
  isTutorialTooltipBlockingInputs,
  completeActiveTutorial,
  customizationNumCompleted,
  lessonNum,
}) => {
  return (
    <div id="main-view">
      <SlideDisplay
        isHidden={hideSlideDisplay}
        slideUrl={slideUrl}
        handleSlidePostMessage={handleSlidePostMessage}
        currPollNumCompleted={currPollNumCompleted}
        discussPhase={discussPhase}
        timerTimes={timerTimes}
        setDisableArrowControls={setDisableArrowControls}
        handleNavigation={handleNavigation}
        timerModalInfo={timerModalInfo}
        setTimerModalInfo={setTimerModalInfo}
        setIsGamePlaying={setIsGamePlaying}
        isTutorialTooltipBlockingInputs={isTutorialTooltipBlockingInputs}
        completeActiveTutorial={completeActiveTutorial}
      />
      {pollResults && (
        <PollResults question={pollQuestion} results={pollResults} />
      )}
      {playtimePhase && (
        <Gameplay
          gameRef={gameRef}
          playtimePhase={playtimePhase}
          gameplayRoute={gameplayRoute}
          isGamePlaying={isGamePlaying}
          setIsGamePlaying={setIsGamePlaying}
          timerTimes={timerTimes}
          setDisableArrowControls={setDisableArrowControls}
          handleNavigation={handleNavigation}
          nextSlideLabel={nextSlideLabel}
          timerModalInfo={timerModalInfo}
          setTimerModalInfo={setTimerModalInfo}
          startTimerModalCallback={startTimerModalCallback}
          isShowingGlossary={isShowingGlossary}
          isTutorialTooltipBlockingInputs={isTutorialTooltipBlockingInputs}
          completeActiveTutorial={completeActiveTutorial}
          customizationNumCompleted={customizationNumCompleted}
          lessonNum={lessonNum}
        />
      )}
    </div>
  );
};

export default MainView;
